import { AdditionalServiceResourceType, ISelectedService, IWorkOrderServiceInfoResource, IWorkOrderSummaryResource, WorkOrderAppointmentInfo, WorkOrderAppointmentInfoState, WorkOrderType } from "../types/session";
import { IconName } from "JS/constants/icons";

export function getSelectedServices(serviceInfo: IWorkOrderServiceInfoResource): ISelectedService[] {
	return serviceInfo?.additionalServices
		?.filter(s => s.isSelected)
		?.map(s => {
			switch (s.type) {
				case AdditionalServiceResourceType.Multiple:
					const option = s.options.find(o => o.blainNumber == s.selectedOptionBlainNumber);
					return {
						icon: s.icon,
						name: `${option.name} ${s.name}`,
					};
				case AdditionalServiceResourceType.Single:
				default:
					return {
						icon: s.icon,
						name: s.name,
					};
			}
		}) ?? [];
}

export function getAppointmentIcon(orderType: WorkOrderType): IconName {
	switch (orderType) {
		case WorkOrderType.Tire:
			return 'tire';
		case WorkOrderType.Battery:
			return 'battery';
		default:
			return 'wrench';
	}
}

export function getAppointmentTitleString(orderType: WorkOrderType): string {
	switch (orderType) {
		case WorkOrderType.Tire:
			return 'Tire Installation';
		case WorkOrderType.Battery:
			return 'Battery Installation';
		default:
			return 'Service';
	}
}

// Appointents can have different times / dates depending on the type of appointment
export function getAppointmentStartDate(appointmentInfo: WorkOrderAppointmentInfo): Date | null {
	if (!appointmentInfo) return null;
	
	switch (appointmentInfo.state) {
		case WorkOrderAppointmentInfoState.Dropoff:
			const startDate = new Date(appointmentInfo.selectedDate);
			startDate.setHours(9);
			return new Date(startDate) ?? null;
		case WorkOrderAppointmentInfoState.TimeSlot:
			return new Date(appointmentInfo.selectedTimeSlot.start);
		default:
			return null;
	}
}

export function getAppointmentEndDate(appointmentInfo: WorkOrderAppointmentInfo): Date | null {
	switch (appointmentInfo.state) {
		case WorkOrderAppointmentInfoState.Dropoff:
			const endDate = new Date(appointmentInfo.selectedDate);
			endDate.setHours(17);
			return new Date(endDate) ?? null;
		case WorkOrderAppointmentInfoState.TimeSlot:
			return new Date(appointmentInfo.selectedTimeSlot.end);
		default:
			return null;
	}
}

export function getAppointmentDateString(startDate: Date, full: boolean = false): string {
	let dateString = startDate.toLocaleDateString('en-us', {
		weekday: "long",
		month: "long",
		day: "numeric",
		year: "numeric"
	});

	if (full) {
		dateString += ' at ';

		dateString += startDate.toLocaleTimeString('en-us', {
			hour: 'numeric',
			minute: '2-digit'
		});
	}

	return dateString;
}


export function getAppointmentTimeString(state: WorkOrderAppointmentInfoState,startDate: Date): string {

	switch (state) {
		case WorkOrderAppointmentInfoState.Dropoff:
			return '9:00 AM';
		case WorkOrderAppointmentInfoState.TimeSlot:
			return startDate.toLocaleTimeString('en-us', {
				hour: 'numeric',
				minute: '2-digit'
			});
		case WorkOrderAppointmentInfoState.Empty:
		default:
			return '';
	}
}


export function getAppointmentTypeString(appointmentInfo: WorkOrderAppointmentInfo): string {
	switch (appointmentInfo.state) {
		case WorkOrderAppointmentInfoState.Dropoff:
			return 'Dropoff';
		case WorkOrderAppointmentInfoState.TimeSlot:
			return 'Wait in store';
		case WorkOrderAppointmentInfoState.Empty:
		default:
			return '';
	}
}

export function getDropoffInstructions(appointmentState: WorkOrderAppointmentInfoState) {
	switch (appointmentState) {
		case WorkOrderAppointmentInfoState.Dropoff:
			return 'Drop off vehicle by 9:00 AM';
		case WorkOrderAppointmentInfoState.TimeSlot:
		case WorkOrderAppointmentInfoState.Empty:
		default:
			return '';
	}
}